import React from 'react';

/**
 * 큐레이션 레스토랑 아이템 스켈레톤 컴포넌트
 * 실제 CurationRestaurantItem과 동일한 구조로 스켈레톤 생성
 */
const CurationRestaurantItemSkeleton: React.FC = () => {
  return (
    <div className="flex-shrink-0 w-72 bg-white rounded-lg overflow-hidden border border-gray-100">
      {/* 레스토랑 이미지 스켈레톤 */}
      <div className="h-32 bg-gray-200 animate-pulse"></div>
      
      {/* 레스토랑 정보 스켈레톤 */}
      <div className="p-3">
        {/* 레스토랑 이름 스켈레톤 */}
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-3/4"></div>
        
        {/* 평점, 거리, 최소주문금액 정보 스켈레톤 */}
        <div className="flex items-center text-xs space-x-2">
          {/* 평점과 리뷰수 스켈레톤 */}
          <div className="flex items-center">
            <div className="w-3 h-3 bg-gray-200 rounded animate-pulse mr-1"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-6"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-10 ml-1"></div>
          </div>
          
          {/* 구분점 스켈레톤 */}
          <div className="w-1 h-1 bg-gray-200 rounded-full animate-pulse"></div>
          
          {/* 거리 정보 스켈레톤 */}
          <div className="h-3 bg-gray-200 rounded animate-pulse w-12"></div>
          
          {/* 구분점 스켈레톤 */}
          <div className="w-1 h-1 bg-gray-200 rounded-full animate-pulse"></div>
          
          {/* 최소주문금액 스켈레톤 */}
          <div className="flex items-center">
            <div className="h-3 bg-gray-200 rounded animate-pulse w-8 mr-1"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-12"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurationRestaurantItemSkeleton; 